import {
  AMSubFormSchema,
  COM360SubFormSchema,
  E360SubFormSchema,
  ecoFitIntegrationSubFormSchema,
  EGYMSubFormSchema,
  Facility360SubFormSchema,
  FacilityConciergeSubFormSchema,
  iFitIntegrationSubFormSchema,
  otherIntegrationSubFormSchema,
  PACESubFormSchema,
  YMCA360IntegrationSubFormSchema,
} from '../../pages/DigitalOrders/order-summary-form-schemas';

export const getProductSchemaAndDetails = (order, value, { facilityNames, facilityExistence }) => {
  switch (value) {
    case 'AM':
      return {
        details: order.productDetails.AM,
        formSchema: AMSubFormSchema(order.productDetails.AM),
      };
    case 'AM_VISION':
      return {
        details: order.productDetails.AM_VISION,
        formSchema: AMSubFormSchema(order.productDetails.AM_VISION),
      };
    case 'COM360':
      return {
        details: order.productDetails.COM360,
        formSchema: COM360SubFormSchema(order.productDetails.COM360),
      };
    case 'ENG360':
      return {
        details: order.productDetails.ENG360,
        formSchema: E360SubFormSchema(order.productDetails.ENG360),
      };
    case 'FACILITY360':
      return {
        details: order.productDetails.FACILITY360,
        formSchema: Facility360SubFormSchema(order.productDetails.FACILITY360),
      };
    case 'FACILITY_CONCIERGE':
      return {
        details: order.productDetails.FACILITY_CONCIERGE,
        formSchema: FacilityConciergeSubFormSchema(order.productDetails.FACILITY_CONCIERGE),
      };
    case 'EGYM':
      return {
        details: order.productDetails.EGYM,
        formSchema: EGYMSubFormSchema(order.productDetails.EGYM),
      };
    case 'PACE':
      return {
        details: order.productDetails.PACE,
        formSchema: PACESubFormSchema(order.productDetails.PACE),
      };
    case 'YMCA360':
      return {
        details: order.productDetails.YMCA360,
        formSchema: YMCA360IntegrationSubFormSchema(order.productDetails.YMCA360),
      };
    case 'iFIT':
      return {
        details: order.productDetails.iFIT,
        formSchema: iFitIntegrationSubFormSchema(
          order.productDetails.iFIT,
          facilityNames,
          facilityExistence,
        ),
      };
    case 'ECOFIT':
      return {
        details: 'ECOFIT',
        formSchema: ecoFitIntegrationSubFormSchema(order.productDetails['ECOFIT']),
      };
    case 'other':
      return {
        details: order.productDetails.other,
        formSchema: otherIntegrationSubFormSchema(order.productDetails.other),
      };
    default:
      return null;
  }
};
